{
  "currency-symbol": "¥",
  "footer": {
    "privacy-policy": "プライバシーポリシー",
    "logout": "ログアウト",
    "logout-confirmation": "ログアウトします。よろしいですか？",
    "questions-email": "questions@aquent.com"
  },
  "talent-happy-path": {
    "country-names": {
      "6": "日本"
    },
    "buttons": {
      "cancel": "キャンセル",
      "yes": "はい"
    },
    "quick-apply": {
      "email-login-page": {
        "email":"Emailまたはユーザーネーム",
        "email-username-invalid": "有効なEメールアドレスまたはユーザーネームを入力してください。",
        "continue": "続ける"
      },
      "header-overline-text": "応募する求人：",
      "welcome-page": {
        "title": "様、エイクエントの求人応募ページへようこそ。",
        "job-board-message": "前回の続きからはじめましょう。",
        "job-board-button": "求人を探す"
      },
      "thank-you-page": {
        "title": "面談にお進みいただく場合はエージェントがご連絡いたします。\nご質問がある場合は、サイトのお問い合わせフォームよりお知らせください",
        "message": "選考の結果、次のステージにお進みいただける場合はエージェントよりご連絡差し上げます。",
        "button-jp": "他の求人を探す"
      },
      "otp-page": {
        "otp-header": "確認コードを入力",
        "otp-helper-info": "{{email}} に送られた6桁の確認コードを入力してメールアドレスを認証してください。",
        "otp-code": "確認コード",
        "otp-resend-helper-info": "確認コードが届きませんか？",
        "otp-resend": "再送する",
        "otp-invalid": "無効なコードです",
        "password-invalid": "無効なパスワードです",
        "sign-in-with-password": "パスワードを使用してサインイン",
        "enter-password": "パスワードを入力してください",
        "forgot-password": "パスワードをお忘れですか？",
        "password": "パスワード",
        "max-attempts": "入力回数が３回を超えました。",
        "code-expired": "コードが無効化されました。"
      },
      "continue": "続ける",
      "back": "戻る",
      "submit-page": {
        "required-fields": "(記載がない限り、すべてのフィールドは必須項目です）",
        "email": "Eメール",
        "email-address": "Eメールアドレス",
        "name": "お名前",
        "firstName": "名",
        "lastName": "姓",
        "phone": "電話番号",
        "homeLocation": "ご自宅住所",
        "homeLocation-placeholder": "郵便番号と住所をご入力ください",
        "communication-preferences": {
          "label": "通知設定",
          "copy": "本求人および関連求人に関するテキストメッセージの受信を希望します。通信料金が適用される場合があります。"
        },
        "personal-info": "個人情報",
        "edit-personal-info": "個人情報を編集する場合：",
        "myaquent": "MyAquent",
        "terms": {
          "copy": "この求人に応募することで、Aquentにタレントとして登録され、職業紹介サービスが提供されることになります。",
          "agree": " に同意します。",
          "terms-of-service": "Aquent の 利用規約"
        },
        "optional": "任意",
        "professional-profile-placeholder": "プロフェッショナル・プロフィールへのURL",
        "professional-profile-hint": "例：LinkedIn、Indeed、など",
        "resume": {
          "last-updated": "最終更新日",
          "upload-text": "新しい履歴書をアップロードする",
          "file-types": "(.pdf, .doc, .docx, .txt, .rtf, .html, .png, .jpg)",
          "button-browse": "ファイルを見る",
          "button-update": "履歴書を更新する",
          "update-existing-info": "A new resume will update your education, skills, and experience in MyAquent",
          "invalid-file-type": "ファイルの種類をご確認ください。アップロードできる容量の上限は20MBです。"
        },
        "submit-application": "応募する",
        "submit-error-header": "送信エラー",
        "submit-error-body": "応募内容を送信時にエラーが発生しました。メールを送信し ",
        "submit-error-message-reference": " 参照番号を記載してください。",
        "submit-error-message-id": " Error ID# {{errorId}}",
        "profile-url-invalid": "無効なURLです。"
      }
    }
  },
  "gather": {
    "interested": {
      "label": "興味あり",
      "compensation": "希望の年収（または時給・報酬）をご入力ください。",
      "available-to-start": "就業開始可能な時期をお知らせください。",
      "enter-annual-salary": "",
      "optional": ""
    },
    "interest": {
      "title": "興味がある職種"
    },
    "enter-url": "",
    "notice-text": "その期間はどれくらいですか？",
    "immediately": "すぐにでも",
    "with-notice": "ある程度の期間を要する",
    "two-weeks-notice": "内定後1か月後",
    "specific-date": "具体的な日付が決まっている",
    "thank-you": "Thank you!",
    "thank-you-text": "この案件にあなたが興味を持っていることが エイクエントへ送信されました。 担当のエージェントよりご連絡させていただく場合があります。",
    "see-more-jobs": "他の求人情報を見る",
    "see-more-jobs-text": "求人情報は常に更新されています。他の求人情報も確認いただき、興味があるものがあればご連絡ください。",
    "back-to-posting": "求人情報詳細を見る",
    "not-interested": {
      "actively-looking": "積極的に転職活動をしている",
      "open-to-opportunities": "良い案件があれば検討したい",
      "not-currently-looking": "すぐに転職するつもりはない",
      "available-to-start": "いつごろ就業開始できますか？",
      "hear-from-us": "マッチしそうな案件があればお知らせして良いですか？",
      "check-in-again": "次にご案内して良いタイミングはいつ頃でしょうか？",
      "check-back-few-months": "数か月後なら通知しても良い",
      "check-back-on": "この日以降ならご案内しても良い",
      "label": "興味なし",
      "title": "興味なし",
      "company-or-industry": "会社/業種が希望と異なる",
      "choose-a-date": "日付を選択してください",
      "pay-rate": "給与が希望と異なる",
      "location": "勤務地が希望と異なる",
      "skill-set": "業務内容が希望と異なる",
      "other": "その他",
      "tell-us-more": "もしよければ具体的に教えてください",
      "primary-reason": "参考までに興味が持てない理由を教えてください",
      "send-feedback": "送信",
      "thank-you-text": "あなたのフィードバックがエイクエントへ送信されました。",
      "still-interested": "現在、求職活動中ですか？",
      "job-search": "現在、転職活動をされていますか？",
      "submit": "送信",
      "reason": {
        "skill-set-mismatch":"スキル・職種がマッチしていない",
        "level-mismatch":"経験値がマッチしていない",
        "pay-rate":"給与・報酬が希望と合わない",
        "location":"就業場所が希望と合わない",
        "industry":"業種が希望と合わない",
        "other":"その他の理由"
      },
      "tell-us-more-interested": "ご質問、メッセージがあればこちらにご入力ください。（任意）"
    },
    "not-interested-text": "案件を辞退されるご理由を教えてください。次回の参考にさせていただきます。",
    "yes": "はい",
    "no": "いいえ",
    "job-closed": {
      "sorry": "We're sorry",
      "sorry-text": "クリックありがとうございます。大変申し訳ありません、この求人の募集は終了しました。"
    },
    "showcase": "ポートフォリオサイトやレジュメ、SNSなどご実績がわかるものをURLにて入力ください。（PDFをお送りいただく場合はご自身でオンラインストレージにアップしていただく必要があります",
    "availability": {
      "confirm": "送信"
    },
    "resume": {
      "update": "最新のレジュメ（履歴書／職務経歴書",
      "upload": "アップロード",
      "none": "ファイルが選択されていません"
    },
    "footer-address": "東京都港区南青山2-11-16 METLIFE青山ビル9階",
    "header1": "お世話になっております。ご経験にマッチする可能性の高い求人情報をお届けいたします。ご興味がある場合は「興味あり」ボタンを押してください。",
    "header2": "",
    "visit-job-center": "求人検索はこちら"
  }
}
